import React from "react";
import { Box, Divider, Pagination, Button, MenuItem } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { Button as Button$1 } from "../button/Buttons.js";
import "../button/EditButton.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { useStyledPaginationClasses } from "../pagination/StyledPagination.js";
import { localizedSelect } from "./Select.js";
const useStyles = makeStyles()((theme) => ({
  multiSelectFooterContainer: {
    position: "sticky",
    bottom: 0,
    background: theme.custom.palette.content.backgroundWhite
  },
  multiSelectFooterSingleButton: {
    paddingLeft: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    color: theme.custom.palette.content.primary,
    "&:hover": {
      textDecoration: "none"
    }
  },
  multiSelectFooterButtons: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1)
  },
  multiSelectFooterPaginationButtons: {
    display: "flex",
    maxWidth: "250px"
  },
  multiSelectFooterButton: {
    border: "none"
  }
}));
function SelectFooter({
  showResetButton,
  onClear,
  showPagination,
  onPageChange,
  page,
  pageSize,
  total,
  showApplyButton,
  onApply
}) {
  const totalPageCount = Math.ceil(total / pageSize);
  const { classes } = useStyles();
  const { classes: paginationClasses } = useStyledPaginationClasses();
  return showResetButton || showPagination ? /* @__PURE__ */ React.createElement(Box, { className: classes.multiSelectFooterContainer, onMouseDown: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement(Divider, null), showPagination || showApplyButton ? /* @__PURE__ */ React.createElement("div", { className: classes.multiSelectFooterButtons }, showPagination ? /* @__PURE__ */ React.createElement(
    Pagination,
    {
      page: page ?? 1,
      count: totalPageCount ?? 1,
      size: "small",
      shape: "rounded",
      siblingCount: 0,
      variant: "outlined",
      className: paginationClasses.pagination,
      onChange: (_, page2) => onPageChange(page2)
    }
  ) : null, showResetButton ? /* @__PURE__ */ React.createElement(
    Button,
    {
      color: "primary",
      "data-testid": "clearSelectButton",
      onClick: onClear,
      className: classes.multiSelectFooterButton
    },
    /* @__PURE__ */ React.createElement(LocalizedText, { label: localizedSelect.selectClearAll })
  ) : null, showApplyButton ? /* @__PURE__ */ React.createElement(
    Button$1,
    {
      color: "primary",
      "data-testid": "applySelectButton",
      onClick: onApply,
      className: classes.multiSelectFooterButton,
      label: localizedSelect.selectApply
    }
  ) : null) : /* @__PURE__ */ React.createElement(MenuItem, { className: classes.multiSelectFooterSingleButton, "data-testid": "clearSelectButton", onClick: onClear }, /* @__PURE__ */ React.createElement(LocalizedText, { label: localizedSelect.selectClearAll }))) : null;
}
export {
  SelectFooter
};
//# sourceMappingURL=MultiSelectFooter.js.map
